export const getIconForTicketType = (type: TicketType | "MUTATION"): string => {
  switch (type) {
    case TicketType.ACTION:
      return "$action"
    case TicketType.MALFUNCTION:
      return "$malfunction"
    case TicketType.INSPECTION:
      return "$inspection"
    case TicketType.NEN1010:
      return "$nen1010"
    case TicketType.NEN3140:
      return "$nen3140"
    case "MUTATION":
      return "$mutation"
  }
}

export const getAvailabilityIcon = (availability: FilterAvailability) => {
  switch (availability) {
    case FilterAvailability.ORGANIZATION:
      return "$organization"
    case FilterAvailability.ORGANIZATION_AND_SUPPLIERS:
      return "public"
    case FilterAvailability.PRIVATE:
      return "$user"
    case FilterAvailability.SUPPLIER_GLOBAL:
      return "$supplier"
  }
}

export const getOrganizationIconByType = (organizationType: OrganizationType) => {
  switch (organizationType) {
    case OrganizationType.CUSTOMER:
      return "$customer"
    case OrganizationType.SUPPLIER:
      return "$supplier"
    case OrganizationType.LABEL:
      return "$label"
    default:
      return "help"
  }
}

export const getContractStatusIcon = (status: ContractStatus): string => {
  switch (status) {
    case ContractStatus.APPROVED:
    case ContractStatus.PARTIALLY_APPROVED:
      return "check_circle"
    case ContractStatus.AWAITING_APPROVAL:
    case ContractStatus.AWAITING_START_DATE:
      return "timer"
    case ContractStatus.DENIED:
      return "cancel"
    case ContractStatus.MANUALLY_ENDED:
    case ContractStatus.EXPIRED:
    case ContractStatus.NO_ACTIVE_PRICE_LISTS:
    case ContractStatus.INVALID_FOR_TICKET:
      return "do_not_disturb_on"
  }
}

export const getPriceListStatusIcon = (status: PriceListStatus): string => {
  switch (status) {
    case PriceListStatus.APPROVED:
      return "check_circle"
    case PriceListStatus.AWAITING_APPROVAL:
    case PriceListStatus.AWAITING_START_DATE:
      return "timer"
    case PriceListStatus.DENIED:
      return "cancel"
    case PriceListStatus.MANUALLY_ENDED:
    case PriceListStatus.EXPIRED:
    case PriceListStatus.INVALID_FOR_TICKET:
      return "do_not_disturb_on"
  }
}

export const getMutationIcon = (mutationType: MutationType) => {
  switch (mutationType) {
    case MutationType.CREATE:
      return "add"
    case MutationType.UPDATE:
      return "$mutation"
    case MutationType.DELETE:
      return "delete"
  }
}
